import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { map } from 'rxjs';
import { ETransportResponseDTO } from 'src/app/models/ETransportModel';
import { FISCOModel } from 'src/app/models/FISCOModel';
import { MilkRunTripPayload, PlannedTripPayload, TripPayload } from 'src/app/models/PackingPlanningModel';
import { EmbalagemService } from 'src/app/services/embalagem/embalagem.service';
import { PackingPlanningService } from 'src/app/services/packing-planning/packing-planning.service';

@Component({
  selector: 'app-packing-integration-form',
  templateUrl: './packing-integration-form.component.html',
  styleUrl: './packing-integration-form.component.css'
})
export class PackingIntegrationFormComponent {

  dropdownOpen: boolean = false;
  fiscoIsVisible: boolean = false;
  eTransportIsVisible: boolean = false;
  planningIsVisible: boolean = false;

  selectedOption: string = "planejado";
  options = ['planejado', 'milk-run'];

  tripCode: string = "";
  plannedTripData: any;

  sharedFiscoData: Partial<FISCOModel> | undefined;
  sharedMilkrunData: Partial<ETransportResponseDTO> | undefined;

  @Output() formSubmitted = new EventEmitter<TripPayload>()
  @Input() dockIdReceived: number | null = null;

  dockNumber: number = 0;

  constructor(private packingService: PackingPlanningService,
    private embalagemService: EmbalagemService,
    private route: ActivatedRoute) { }

  ngOnInit(): void {
    // Observa as mudanças nos parâmetros da URL
    this.route.params.subscribe(params => {
      const dockIdFromUrl = +params['id']; // captura o 'id' da URL
      if (dockIdFromUrl) {
        const dockMap = new Map<number, number>([
          [12, 1],
          [1, 2],
          [5, 3],
          [6, 4],
          [11, 5],
        ]);

        const mapped = dockMap.get(dockIdFromUrl);
        this.dockNumber = mapped ?? 0;
      }
    });
  }

  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen
  }

  selectOption(option: string) {
    this.selectedOption = option
    this.dropdownOpen = false
  }

  // INPUT FILTER  
  filterTripByCode() {
    if (!this.tripCode || this.tripCode.trim() === '') return;

    try {
      this.packingService.getAllTrips().pipe(
        map(d => {
          const code = this.tripCode?.trim().toLowerCase();
          return d.find(trip => trip.trip && trip.trip.toLowerCase() === code);
        })
      ).subscribe(filteredTrip => {
        this.plannedTripData = filteredTrip ?? undefined;
      });
    } catch (err) {
      console.error('Erro durante a filtragem:', err);
    }
  }

  shareTripData() {
    if (this.selectedOption === "milk-run") {
      const finalObject: MilkRunTripPayload = {
        diferencial: 'milk-run',
        registro: this.sharedMilkrunData?.Sequencia ?? null,
        transportadora: this.sharedMilkrunData?.Transportadora ?? null,
        janela: this.sharedMilkrunData?.Janela ?? null,
        placa: this.sharedMilkrunData?.Plate ?? '',
        area: this.sharedMilkrunData?.Area ?? null,
      };
      this.formSubmitted.emit(finalObject)

      const { diferencial, ...payload } = finalObject

      this.embalagemService.updateTrucksTable(payload, this.dockIdReceived!, diferencial).subscribe({
        next: () => {
          alert("Viagem atualizada")
        },
        error: (error) => {
          console.error("Erro ao atualizar dados: ", error);
          alert("Erro ao atualizar viagem");
        },
      })

    } else {
      const finalObject: PlannedTripPayload = {
        diferencial: 'planned',
        viagem: this.tripCode,
        categoria: this.plannedTripData.category,
        transportadora: this.sharedFiscoData?.fornecedor ?? null,
        chegada: this.plannedTripData.arrivalTime,
        saida: this.plannedTripData.departureTime,
        registro: this.sharedFiscoData?.sequencia?.toString() ?? '',
        placa: this.sharedFiscoData?.placaVeiculo ?? '',
      };
      this.formSubmitted.emit(finalObject)
      const { diferencial, ...payload } = finalObject

      this.embalagemService.updateTrucksTable(payload, this.dockIdReceived!, diferencial).subscribe({
        next: () => {
          alert("Viagem atualizada")
        },
        error: (error) => {
          console.error("Erro ao atualizar dados: ", error);
          alert("Erro ao atualizar viagem");
        },
      })
    }
  }

  clearFields() {
    this.tripCode = "";
    this.sharedFiscoData = undefined
    this.sharedMilkrunData = undefined
    this.plannedTripData = undefined
  }

  // SHARED DATA
  handleSelectFisco(data: FISCOModel) {
    const FISCOData = {
      sequencia: data.sequencia,
      fornecedor: data.fornecedor,
      placaVeiculo: data.placaVeiculo,
      tipoEntrada: data.tipoEntrada,
      entrada: data.entrada,
    }
    this.sharedFiscoData = FISCOData
  }

  handleSelectMilkrun(data: ETransportResponseDTO) {
    this.sharedMilkrunData = data
  }

  // CSS
  get isMilkRun(): boolean {
    return this.selectedOption === 'milk-run';
  }

  get isPlanned(): boolean {
    return this.selectedOption === 'planejado';
  }


  // TOGGLE AUXILIARY TABLES

  toggleFisco() {
    this.fiscoIsVisible = !this.fiscoIsVisible
  }

  toggleEtransport() {
    this.eTransportIsVisible = !this.eTransportIsVisible
  }

  togglePlanning() {
    this.planningIsVisible = !this.planningIsVisible
  }
}
